export default "__VITE_ASSET__2mIUAQ6v__"